import { Button as AntButton, Descriptions, Modal, Select } from "antd";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { getStudent, getStudentPtInfo, getStudentTestInfo } from "../../../../api/students.api";
import { getStudentClasses } from "../../../../api/studentsClass.api";
import { confirmCode, generateCode, transferCampus } from "../../../../api/studentsMoveCampus.api";
import useAxios from "../../../../hooks/useAxios";
import useNotification from "../../../../hooks/useNotification";
import { getCommonCodeLabel } from "../../../../lib/store";
import { addHyphen, getWebUrl } from "../../../../lib/util";
import { ICampusItem } from "../../../../models/campuses.model";
import { IGetStudent, IGetStudentPtInfo, IGetStudentTestInfo } from "../../../../models/students.model";
import { IGetStudentClasses } from "../../../../models/studentsClass.model";
import { IConfirmCode, IGenerateCode } from "../../../../models/studentsMoveCampus.model";
import { RootState } from "../../../../store/rootReducer";
import Button from "../../../Button";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";
import ConfirmTransferModal from "./ConfirmTransferModal";
import Timer1 from "./Timer1";
import Timer2 from "./Timer2";
import { useHistory } from "react-router-dom";
import SelectCampus from "../../../SelectCampus";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  doGetAllStudents: () => void;
  setMemberCode: (memberCode: string) => void;
  setCampusCode: (campusCode: string) => void;
}

const TransferCampusModal: FC<IProps> = ({
  visible,
  setVisible,
  doGetAllStudents,
  setMemberCode,
  setCampusCode,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetStudent>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetStudentClasses>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetStudentTestInfo>();
  const { data: res4, isLoading: isLoading4, error: error4, execute: execute4 } = useAxios<IGetStudentPtInfo>();  
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios<IGenerateCode>();
  const { data: submitRes2, isLoading: submitIsLoading2, error: submitError2, execute: submitExecute2 } = useAxios<IConfirmCode>();
  const { data: submitRes3, isLoading: submitIsLoading3, error: submitError3, execute: submitExecute3 } = useAxios();

  const [width, setWidth] = useState(400);
  const [step, setStep] = useState(1);
  const [nowCampusCode, setNowCampusCode] = useState('');
  const [parentName, setParentName] = useState('');
  const [studentName, setStudentName] = useState('');
  const [mobilePhone, setMobilePhone] = useState('');
  const [target, setTarget] = useState('');
  const [certifyKey, setCertifyKey] = useState('');
  const [nextCampusCode, setNextCampusCode] = useState('');
  const [confirmTransferVisible, setConfirmTransferVisible] = useState(false);
  const { warningNotification, errorNotification } = useNotification();

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      setTarget(submitRes.data);
      setStep(2);
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (submitRes2 && !submitIsLoading2) {
      const memberCode = submitRes2.data;
      execute(getStudent(memberCode, nowCampusCode));
      execute2(getStudentClasses(memberCode));
      execute3(getStudentTestInfo(memberCode));
      execute4(getStudentPtInfo(memberCode));
      setWidth(750);
      setStep(3);
    }
  }, [submitRes2, submitIsLoading2]);

  useEffect(() => {
    if (!submitError2?.response?.status) return;
    switch (submitError2.response.status) {
      case 400:
        if(submitError2.response?.data.data === '해당 학생이 없습니다.') {
          warningNotification(t('shuttle.text.52'));
        } else {
          warningNotification(
            (submitError2.response?.data.data || t('common.message.error')),
          );
        }
        break;
      case 403:
        warningNotification(t('common.message.forbidden'));
        history.push('/');
        break;
      case 404:
        warningNotification(t('common.message.notFound'));
        break;
      default:
        errorNotification(
          submitError2.response?.data.data ||
          submitError2.response?.data.error ||
            t('common.message.error'),
        );
    }
  }, [submitError2])

  useEffect(() => {
    if (submitRes3 && !submitIsLoading3) {
      doGetAllStudents();
      onClose();
      setMemberCode('');
      setCampusCode('');
      history.push('/student/student');
      successNotification(t('student.student.message48'));
    }
  }, [submitRes3, submitIsLoading3]);

  const onClose = () => {
    setWidth(500);
    setStep(1);
    setNowCampusCode('');
    setParentName('');
    setStudentName('');
    setMobilePhone('');
    setTarget('');
    setCertifyKey('');
    setVisible(false);
  }

  const getFooter = () => {
    const footer = [];

    if (step < 3) {
      footer.push(
        <AntButton
          key="submit"
          className='btn-basic pink'
          onClick={onConfirmCode}
          disabled={step < 2 && auth.hqYn === 'N'}
        >
          {t('common.button.confirm')}
        </AntButton>
      );
    } else {
      footer.push(
        <AntButton
          key="submit"
          className='btn-basic pink'
          onClick={() => setConfirmTransferVisible(true)}
        >
          {t('student.student.button25')}
        </AntButton>
      );
    }

    footer.push(
      <AntButton
        key="cancel"
        className='btn-basic gray'
        onClick={onClose}
      >
        {t('common.button.cancel')}
      </AntButton>
    );

    return <div className='comm-btn__area justify-content-center'>{footer}</div>;
  }

  const onOpenReportCard = (examTestCode: number) => {
    window.open(`${getWebUrl()}/report-card?examTestCode=${examTestCode}`, '_blank', 'width=990, height=768, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=yes');
  }

  const onGenerateCode = () => {
    if (!nowCampusCode) {
      return infoNotification(t('student.student.message49'));
    }
    if (!parentName) {
      return infoNotification(t('student.student.message50'));
    }
    if (!studentName) {
      return infoNotification(t('student.student.message51'));
    }
    if (!mobilePhone) {
      return infoNotification(t('student.student.message5'));
    }

    submitExecute(generateCode({
      nowCampusCode,
      parentName,
      studentName,
      mobilePhone,
    }));
  }

  const onConfirmCode = () => {
    if (auth.hqYn === 'N' && !certifyKey) {
      return infoNotification(t('auth.findId.message4'));
    }

    const req: any = {
      nowCampusCode,
      parentName,
      studentName,
      mobilePhone,
    };

    if (auth.hqYn === 'N') {
      req.target = target;
      req.certifyKey = certifyKey;
    }

    submitExecute2(confirmCode(req));
  }

  const onTransferCampus = () => {
    if (!nextCampusCode) {
      return infoNotification(t('student.student.message52'));
    }
    if (nowCampusCode === nextCampusCode) {
      return infoNotification(t('student.student.message53'));
    }

    const req: any = {
      nowCampusCode,
      parentName,
      studentName,
      mobilePhone,
      nextCampusCode,
    };

    if (auth.hqYn === 'N') {
      req.target = target;
      req.certifyKey = certifyKey;     
    }

    submitExecute3(transferCampus(req));
  }

  return (
    <>
      {isLoading || isLoading2 || isLoading3 || isLoading4 || submitIsLoading || submitIsLoading2 || submitIsLoading3 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={submitError} />
      {/*<ErrorResponse error={submitError2} />*/}
      <ErrorResponse error={submitError3} />

      <Modal
        title={t('student.student.button1')}
        visible={visible}
        onCancel={onClose}
        className='comm-btn__area'
        width={width}
        footer={getFooter()}
      >
        {
          step < 3
            ? (
              <div className='comm-table__area line-type mt-0' style={{width:width}}>
                <Descriptions
                  bordered
                  column={1}
                  size="small"
                >
                  <Descriptions.Item label={t('student.student.column127')}>
                    <SelectCampus 
                      key={`transferCampusModal`}
                      className="w-100"
                      placeholder={t('class.class.placeholder1')}
                      value={nowCampusCode} 
                      onChange={(value: string) => setNowCampusCode(value)}
                      disabled={step > 1}
                    />

                  </Descriptions.Item>
                  <Descriptions.Item label={t('student.student.option32')}>
                    <input
                      type="text"
                      className="form-control input-text"
                      value={parentName}
                      onChange={e => setParentName(e.target.value)}
                      disabled={step > 1}
                    />
                  </Descriptions.Item>
                  <Descriptions.Item label={t('student.student.column128')}>
                    <input
                      type="text"
                      className="form-control input-text"
                      value={studentName}
                      onChange={e => setStudentName(e.target.value)}
                      disabled={step > 1}
                    />
                  </Descriptions.Item>
                  <Descriptions.Item label={t('student.student.option33')}>
                    <div className="flex">
                      <input
                        type="text"
                        className="form-control input-text"
                        placeholder={t('student.student.placeholder8')}
                        value={mobilePhone}
                        onChange={e => setMobilePhone(e.target.value)}
                        /*onKeyPress={e => { if (e.key === 'Enter') onGenerateCode() }}*/
                        disabled={step > 1}
                      />
                      {/*
                      <div className="comm-btn__area">
                        <Button
                          className='btn-basic mint ml-2'
                          style={{width:'130px'}}
                          onClick={onGenerateCode}
                          text={t('student.student.button26')}
                          disabled={step > 1}
                        />
                      </div>
                      */}
                    </div>
                  </Descriptions.Item>
                  {
                    step === 2
                      ? (
                        <Descriptions.Item label={t('student.student.column129')}>
                          <div className="flex">
                            <input
                              type="text"
                              className="form-control input-text"
                              value={certifyKey}
                              onChange={e => setCertifyKey(e.target.value)}
                              onKeyPress={e => { if (e.key === 'Enter') onConfirmCode() }}
                              disabled={step > 2}
                            />
                            {
                              step === 2
                                ? (
                                  <div className="w-100p v-line ml-2">
                                    <Timer1 />
                                  </div>
                                )
                                : null
                            }
                          </div>
                        </Descriptions.Item>      
                        )
                      : null
                  }
                </Descriptions>
              </div>
              )
            : (
              <>
                <div className="comm-bx__space" style={{width:width}}>
                  <div className="comm-btn__area right">
                    <Timer2 onClose={onClose} />
                  </div>
                </div>
                <div className='comm-table__area rowType stats mt-0'>
                  <table>
                    <colgroup>
                      <col width="20%" />
                      <col width="20%" />
                      <col width="20%" />
                      <col width="20%" />
                      <col width="20%" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <td rowSpan={4}>
                          <img
                            className="img-preview"
                            src={res?.data?.profileImg?.thumbnailLocation || res?.data?.profileImg?.fileLocation || undefined}
                            alt="student"
                            style={{ maxWidth: '100%', maxHeight: '100%' }}
                          />
                        </td>
                        <th>{t('student.student.column5')} (ID)</th>
                        <td>{res?.data?.studentKorName} ({res?.data?.webId})</td>
                        <th>{t('student.student.column6')}</th>
                        <td>{res?.data?.studentEngName}</td>
                      </tr>
                      <tr>
                        <th>{t('class.class.placeholder1')}</th>
                        <td>{res?.data?.campusKorName}</td>
                        <th>{t('common.menu.pt')}</th>
                        <td>
                          {
                            res4?.data?.examDate
                              ? `${moment(res4.data.examDate).format('YYYY.MM.DD')} (${res4?.data?.courseName})`
                              : '-'
                          }
                        </td>
                      </tr>
                      <tr>
                        <th>{t('student.student.column7')}</th>
                        <td>{moment(res?.data?.birthday).format('YYYY.MM.DD')}</td>
                        <th>{t('student.student.placeholder1')}</th>
                        <td>{addHyphen(res?.data?.mobilePhone)}</td>
                      </tr>
                      <tr>
                        <th>{t('student.student.column2')}</th>
                        <td>{res?.data?.schoolName}</td>
                        <th>{t('student.student.column3')}</th>
                        <td>{getCommonCodeLabel('SY0006', res?.data?.gradeCode || '', 'ko')}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="comm-bx__between">
                <h3 className="sub-title">{t('student.student.title21')}</h3>
                </div>
                <div className='comm-table__area rowType stats mt-0'>
                  <table>
                    <tbody>
                      <tr>
                        <th>{t('student.student.column22')}</th>
                        <th>{t('student.student.column23')}</th>
                        <th>{t('student.student.column24')}</th>
                        <th>{t('student.student.column25')}</th>
                        <th>{t('student.student.column26')}</th>
                        <th>{t('student.student.column27')}</th>
                        <th>{t('student.student.column4')}</th>
                      </tr>
                      {res2?.data?.map(item => (
                        <tr>
                          <th>{item.semesterName}</th>
                          <th>{item.className}</th>
                          <th>{moment(item.semesterSrtDate).format('YYYY.MM.DD')}</th>
                          <th>{moment(item.semesterEndDate).format('YYYY.MM.DD')}</th>
                          <th>{item.levelName}</th>
                          <th>{item.courseName}</th>
                          <th>{getCommonCodeLabel('CL0003', item.studyStatus, 'ko')}</th>
                        </tr>
                      ))}
                      {
                        res2?.data?.length
                          ? null
                          : (
                            <tr>
                              <td colSpan={7}>{t('student.student.message54')}</td>
                            </tr>
                            )
                      }
                    </tbody>
                  </table>
                </div>

                <div className="comm-bx__between">
                  <h3 className="sub-title">{t('student.student.title22')}</h3>
                </div>
                <div className='comm-table__area rowType stats mt-0'>
                  <table>
                    <tbody>
                      <tr>
                        <th>{t('common.column.category')}</th>
                        <th>{t('student.student.column132')}</th>
                        <th>{t('student.student.column133')}</th>
                        <th>{t('student.student.column134')}</th>
                        <th>{t('student.student.column135')}</th>
                        <th>{t('student.student.column136')}</th>
                      </tr>
                      {res3?.data?.map(item => (
                        <tr>
                          <td>{getCommonCodeLabel('TE0001', item.examDiv, 'ko')}</td>
                          <td>{item.examTypeName}</td>
                          <td>{item.examName}</td>
                          <td>{item.studentScore || '-'}</td>
                          <td>
                            {
                              item.examSrtDate
                                ? moment(item.examSrtDate).format('YYYY.MM.DD')
                                : '-'
                            }
                          </td>
                          <td>
                            {
                              item.examDiv === 'PT'
                                ? (
                                  <Button
                                    className='btn btn-sm btn-primary btn-w100p ml-2'
                                    onClick={() => onOpenReportCard(item.examTestCode)}
                                    text={t('student.student.column136')}
                                  />
                                  )
                                : '-'
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
              )
        }
      </Modal>

      <ConfirmTransferModal
        visible={confirmTransferVisible}
        setVisible={setConfirmTransferVisible}
        nextCampusCode={nextCampusCode}
        setNextCampusCode={setNextCampusCode}
        onTransferCampus={onTransferCampus}
      />
    </>
  );
}

export default TransferCampusModal;
